import React, { FC, useContext, useMemo } from "react";
import { useSelector } from "react-redux";

import { HeaderTitle, LayerDescription, TitleContainer } from "../../styled";
import { FeatureCardContext } from "./FeatureCardContext";
import { getSourceAttributeName, getSourceLayerInfo } from "../../../../ducks/showFeature/selectors";
import { getRelatedAttribute } from "../../utils/getRelatedAttribute";
import { formatAttributeValue } from "../../../../utils/formatAttributeValue";

export const FeatureCardTitle: FC<{ title: string; description: string }> = ({ title, description }) => {
  const { featureName, attributes, layerInfo, feature } = useContext(FeatureCardContext);
  const sourceAttributeName = useSelector(getSourceAttributeName);
  const sourceLayerInfo = useSelector(getSourceLayerInfo);

  const { alias, name, layerDefinition } = layerInfo || {};
  const resultDescription = description || alias || name || "";

  const resultTitle = useMemo(() => {
    const layerDefinitionAttribute =
      layerDefinition && attributes?.length
        ? attributes.find(item => item.name === layerDefinition.titleAttribute)
        : null;
    const layerDefinitionTitle =
      layerDefinition?.titleAttribute && layerDefinitionAttribute?.value
        ? (layerDefinitionAttribute.value as string)
        : null;
    const sourceTitleAttribute =
      sourceLayerInfo?.titleAttribute && attributes?.length
        ? attributes.find(item => item.name === sourceLayerInfo.titleAttribute)
        : null;
    const sourceTitle =
      sourceLayerInfo?.titleAttribute && sourceTitleAttribute?.value ? (sourceTitleAttribute.value as string) : null;
    const relatedAttributeTitle = getRelatedAttribute(
      sourceLayerInfo,
      sourceAttributeName,
      feature?.layer,
    )?.attributeTitle;
    const relatedAttribute =
      relatedAttributeTitle && attributes?.length ? attributes.find(item => item.name === relatedAttributeTitle) : null;
    const attributeValue = relatedAttribute
      ? formatAttributeValue(relatedAttribute.type, relatedAttribute.value, relatedAttribute.stringFormat)
      : null;

    return (
      title ||
      (!!attributeValue &&
        formatAttributeValue(relatedAttribute.type, attributeValue, relatedAttribute.stringFormat)) ||
      (!!sourceTitle &&
        formatAttributeValue(sourceTitleAttribute.type, sourceTitle, sourceTitleAttribute.stringFormat)) ||
      (!!layerDefinitionTitle &&
        formatAttributeValue(
          layerDefinitionAttribute.type,
          layerDefinitionTitle,
          layerDefinitionAttribute.stringFormat,
        )) ||
      featureName
    );
  }, [attributes, feature?.layer, featureName, layerDefinition, sourceAttributeName, sourceLayerInfo, title]);

  return (
    <TitleContainer>
      <HeaderTitle title={resultTitle}>{resultTitle}</HeaderTitle>
      <LayerDescription title={resultDescription}>{resultDescription}</LayerDescription>
    </TitleContainer>
  );
};
